import React from 'react';
import familyIcon from '../../images/icon-family.svg';
import charitableIcon from '../../images/icon-charitable.svg';
import education from '../../images/icon-education.svg';
import engagement from '../../images/icon-engagement.svg';
import organization from '../../images/icon-Organization.svg';
import professional from '../../images/icon-professional.svg';
import person from '../../images/icon-personal.svg';
import styles from './default_icon.module.css';

export const FamilyIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={familyIcon} alt='' />
    </div>
  );
}

export const PersonIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={person} alt='' />
    </div>
  );
}

export const PersonalIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={professional} alt='' />
    </div>
  );
}

export const ProfessionalIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={organization} alt='' />
    </div>
  );
}

export const EducationIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={education} alt='' />
    </div>
  );
}

export const EngagementIcon = ({ className = styles.engagement_icon, imgClassName = styles.engagement_icon_img }) => {
  return (
    <div className={className}>
      <img className={imgClassName} src={engagement} alt='' />
    </div>
  );
}

export const EventIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2H11V1C11 0.45 10.55 0 10 0C9.45 0 9 0.45 9 1V2H7V1C7 0.45 6.55 0 6 0C5.45 0 5 0.45 5 1V2H4C2.9 2 2 2.9 2 4V14C2 15.1 2.9 16 4 16H12C13.1 16 14 15.1 14 14V4C14 2.9 13.1 2 12 2ZM12 14H4V7H12V14ZM12 5H4V4H12V5Z"
      fill="currentColor"
    />
  </svg>
);

export const CharitableIcon = ({ className }) => {
  return (
    <div className={className}>
      <img src={charitableIcon} alt='' />
    </div>
  );
}